// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"1858158b","231":"91cd5708","406":"28c9e641","453":"d2b759d7","810":"fcd6caa8","960":"b7ad6256"}[chunkId] + ".chunk.js";
};